import React from "react";
import { motion } from "motion/react";

const NewsCard = ({ img, title, descrpition }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: false, amount: 0.5 }}
    >
      <img
        src={img}
        alt="image"
        className=" my-2 w-full h-72 object-cover rounded-xl"
      />
      <h2 className="my-2 text-xl font-semibold text-g-black">{title}</h2>
      <p className="my-2 text-md text-deep-grey">{descrpition}</p>
    </motion.div>
  );
};

export default NewsCard;
